"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResizeObserver = void 0;
const react_1 = require("react");
const useResizeObserver = (ref) => {
    const [width, setWidth] = (0, react_1.useState)(null);
    const [height, setHeight] = (0, react_1.useState)(null);
    const [observer] = (0, react_1.useState)(new ResizeObserver((entries) => {
        const { width, height } = entries[0].contentRect;
        setWidth((prevState) => (prevState !== width ? width : prevState));
        setHeight((prevState) => (prevState !== height ? height : prevState));
    }));
    (0, react_1.useEffect)(() => {
        const element = ref.current;
        if (element) {
            observer.observe(element);
            return () => {
                observer.disconnect();
            };
        }
        return;
    }, [ref, observer]);
    return { width, height };
};
exports.useResizeObserver = useResizeObserver;
exports.default = exports.useResizeObserver;
//# sourceMappingURL=useResizeObserver.js.map